import validator from 'validator';
import isEmpty from 'lodash/isEmpty';

export default function validateUserChangePassword(data) {
  let errors = {};

  if (validator.isEmpty(data.current_password)) {
      errors.current_password = 'This field is required';
  }
  if (validator.isEmpty(data.new_password)) {
    errors.new_password = 'This field is required';
  }
  if (validator.isEmpty(data.confirm_new_password)) {
      errors.confirm_new_password = 'This field is required';
  }
  if (!validator.equals(data.new_password, data.confirm_new_password)) {
      errors.confirm_new_password = 'Passwords must match';
  }

  return {
    errors,
    isValid: isEmpty(errors),
    isFormValid:isEmpty(errors)
  }
}